<div class="ui-flexgrid-paginator">
  <p-paginator
    [totalRecords]="totalRecords"
    [rowsPerPageOptions]="this.rowsPerPageOptions"
    [rows]="defaultNumRows"
    (onPageChange)="onPageChange($event)"
  ></p-paginator>
</div>
